import React from 'react'
import { Box } from '@mui/joy'
import { useFormatter } from '../../utils';

const CellGenericListCount = ({ value, type = 'listcount' }) => {

    return (
        <Box className={"list-element-cell cell-" + type}>
            {(value ?? []).length}
        </Box>
    )
}

export default CellGenericListCount